/* eslint-disable import/prefer-default-export */
export const comesFromValidPreviousPath = (objectRoutes, objectlocation) => {
  if (!objectlocation.state) return false;
  const thisObjectRoute = Object.values(objectRoutes).filter(
    (el) => el.path === objectlocation.pathname
  )[0];
  return thisObjectRoute.previousPath === objectlocation.state.from;
};
